import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="min-h-[60vh] flex items-center justify-center text-slate-400">Article not found.</div>;
  if (!post) return <div className="min-h-[60vh] flex items-center justify-center text-slate-500">Loading…</div>;

  return (
    <div className="bg-navy-base min-h-screen" data-testid="blog-post-page">
      <SEO title={`${post.title} | XTM Knowledge Hub`} description={post.excerpt} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <span className="text-[10px] font-bold uppercase tracking-wider text-orange-400 border border-orange-500/40 rounded-full px-2.5 py-1">{post.category}</span>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white mt-4 mb-4" data-testid="blog-post-title">{post.title}</h1>
        <p className="text-xs text-slate-500 mb-8">{new Date(post.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })} • {post.author}</p>
        <img src={post.cover} alt={post.title} className="w-full h-64 object-cover rounded-2xl border border-white/10 mb-8" loading="lazy" />
        <div className="space-y-5">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i} className="text-base text-slate-300 leading-relaxed">{para}</p>
          ))}
        </div>
        <div className="mt-12 bg-card border border-white/10 rounded-2xl p-7">
          <h3 className="font-display text-lg font-semibold text-white mb-2">Ready to start learning?</h3>
          <p className="text-sm text-slate-400 mb-5">Explore career-oriented programs at XTM FutureSkills Academy, Jorhat.</p>
          <Button asChild className="bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-full px-7 transition-colors" data-testid="blog-cta-btn">
            <Link to="/courses">Explore Courses</Link>
          </Button>
        </div>
      </article>
    </div>
  );
}
